import { Helmet } from "react-helmet";
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Container,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Toolbar,
    Typography,
    Avatar,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import bannerBg from "../../../assets/images/home/home-banner-bg.svg";
import bannerImg from "../../../assets/images/home/banner-image.svg";
import planningImg from "../../../assets/images/home/planning.svg";
import saveImg from "../../../assets/images/home/save.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import cssVariables from "../../../theme/cssVariables";
import React, { useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import AttachFilesDialog from "../../../components/workloadAndPerformance/AttachFilesDialog";
import { ReactComponent as TrashIcon } from "../../../assets/images/portfolio/trash-alt.svg";
import core from "../../../assets/images/competency/core.svg";
import coreBlack from "../../../assets/images/competency/core-black.svg";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import StarIcon from '@mui/icons-material/StarOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from "@mui/styles";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as DownIcon } from "../../../assets/images/competency/chevrons-down.svg";
import { ReactComponent as UpIcon } from "../../../assets/images/competency/chevrons-up.svg";
import { ReactComponent as ListFile } from "../../../assets/images/listFile.svg";
import emty from "../../../assets/images/emty.png";
import Search from "@mui/icons-material/Search";
import MenuFilter from "../../../components/kpi/MenuFilter";
import competencyService from "../../../services/competency.service";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}
const useStyles = makeStyles({

});
const Ratings = styled(Rating)({
    '& .MuiRating-icon': {
        color: '#F7B254 !important',
    },
});
const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
        cursor: "pointer",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};
const SeeAllCompetency = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState('all');
    const [valueSerial, setValueSerial] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [evaluated, setEvaluated] = React.useState(true);
    const [notEvaluated, setNotEvaluated] = React.useState(true);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [setSeeAllLimit, setSeeAllLimitValue] = React.useState(10);
    const [filteredList, setFilteredList] = React.useState([]);
    const [is_owner, setIsOwner] = React.useState(true);
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    let { type, serial, member } = useParams();
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [mainData, setMainData] = React.useState({});
    const [filterData, setFilterData] = React.useState({});
    const [dataAll, setDataAll] = React.useState([]);
    const [category, setCategory] = React.useState("-");
    let getDataCompetency = () => {
        let pathData = ""
        if (formatData(serial, false) !== false && formatData(member, false) !== false) {
            pathData = `app/kpi/competency?kpi_form_id=${serial}&employee_id=${member}`
        } else {
            if (formatData(serial, false) !== false) {
                pathData = `app/kpi/competency?kpi_form_id=${serial}`
            }
            if (formatData(member, false) !== false) {
                pathData = `app/kpi/competency?employee_id=${member}`
            }
        }
        competencyService.competency(pathData).then(
            (response) => {
                setMainData(response.data)
                setFilterData(response.data)
                setIsOwner(formatData(response.data?.is_owner, "") !== "" ? response.data?.is_owner : "")
                if (response?.data?.list[type]) {
                    setFilteredList(response.data.list[type])
                    setDataAll(response.data.list[type])
                }
                if (response?.data?.competency_type !== undefined && response?.data?.competency_type.length > 0) {
                    let findData = response?.data?.competency_type.filter(rs => rs.code === type)
                    if (findData.length > 0 && findData[0]?.name !== undefined && findData[0]?.name !== null) {
                        setCategory(findData[0]?.name)
                    }
                }
            },
        );
    }
    const handleTooltipOpen = (data) => {
        if (data !== valueSerial) {
            setOpen(true)
            setValueSerial(data)
        } else {
            setOpen(false)
            setValueSerial("")
        }
    };
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    const StyledRating = styled(Rating)({
        '& .MuiRating-icon': {
            color: "#F7B254 !important"
        },
    });
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest(".tooltip") === null) {
                setOpen(false)
                setValueSerial("")
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    });
    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const handleTotalPage = () => {
        const List = filteredList
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    // update qty for each status when list changed
    useEffect(() => {
        handleTotalPage();
    }, [filteredList, perPage]);
    useEffect(() => {
        getDataCompetency()
    }, [])

    const currentData = useMemo(() => {
        handleTotalPage();
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return filteredList
            // ?.filter(item => selectedWorkloadType !== "all" ? item.workType == selectedWorkloadType : item)
            .slice(firstPageIndex, lastPageIndex);
    }, [filteredList, currentPage, perPage]);
    const statusOpen = (data) => {
        setOpenMenu(data)
    }
    const EditNotEvaluated = (data) => {
        if (data === "notEvaluated") {
            setNotEvaluated(!notEvaluated)
        } else if (data === "evaluated") {
            setEvaluated(!evaluated)
        } else if (data === "selectAll") {
            if (notEvaluated === true && evaluated === true) {
                setNotEvaluated(false)
                setEvaluated(false)
            } else if (notEvaluated === false && evaluated === false) {
                setNotEvaluated(true)
                setEvaluated(true)
            } else if (notEvaluated === true || evaluated === true) {
                setNotEvaluated(true)
                setEvaluated(true)
            }
        }
    };
    const [search, setSearchValue] = React.useState("");
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    useEffect(() => {
        dataSerachs()
    }, [search, notEvaluated, evaluated]);
    const dataSerachs = async (event) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(dataAll))
        if (search !== "") {
            result = dataSerach.filter((item) => {
                return Object.keys(item).some((key) => {
                    if (key === 'name' || key === 'code' || key === 'category') {
                        return item[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'proficiency') {
                        if (item[key] !== undefined && item[key] !== null && item[key] !== "") {
                            return Object.keys(item[key]).some(keys => {
                                return item[key][keys].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                            });
                        }

                    }
                });
            });
        } else {
            result = dataSerach;
        }
        await filterEvaluatedSerach(result)
    };

    const filterEvaluatedSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (notEvaluated === false && evaluated === false) {
            setFilteredList([])
        } else if (notEvaluated === true && evaluated === true) {
            setFilteredList(data)
        } else {
            if (notEvaluated === true) {
                for (let index = 0; index <= dataFilter.length - 1; index++) {
                    if (dataFilter[index]?.is_evaluate === false) {
                        result.push(dataFilter[index]);
                    }
                }
                setFilteredList(result)
            } else if (evaluated === true) {
                for (let index = 0; index <= dataFilter.length - 1; index++) {
                    if (dataFilter[index]?.is_evaluate === true) {
                        result.push(dataFilter[index]);
                    }
                }
                setFilteredList(result)
            }
        }
        // if (notEvaluated === false && evaluated === false) {
        //     setFilteredList([])
        // } else if (notEvaluated === true && evaluated === true) {
        //     setFilteredList(data)
        // } else {
        //     if (notEvaluated === true) {
        //         for (let index = 0; index <= Object.keys(dataFilter).length - 1; index++) {
        //             let resultData = dataFilter[Object.keys(dataFilter)[index]].filter(rs => rs?.is_evaluate === false);
        //             result[Object.keys(dataFilter)[index]] = resultData
        //         }
        //         setFilteredList(result)
        //     } else if (evaluated === true) {
        //         for (let index = 0; index <= dataFilter.length - 1; index++) {
        //             let resultData = dataFilter[index].filter(rs => rs?.is_evaluate === true);
        //             result[Object.keys(dataFilter)[index]] = resultData
        //         }
        //         setFilteredList(result)
        //     }
        // }
    };
    return (
        <>
            <Helmet>
                <title>HOME | KPI </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "background.default",
                    minHeight: "100%",
                    py: 3,
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        {is_owner === false ?
                            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/team-member')}>{t('competency.teamMember')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency/${member}`)} >{formatData(mainData?.owner_profile?.fullname, "-")}</span> / <span style={styles.end} onClick={() => clickLink(`/kpi/competency`)}>{t('competency.myName')}</span></Typography>
                            : is_owner === true ?
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency`)}>{t('competency.myName')}</span> / <span style={styles.end} >{category}</span></Typography>
                                :
                                <Typography fontSize={16} lineHeight={1} color="#68717A"></Typography>
                        }
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item lg={12} md={12} xs={12} display="flex" alignItems="center">
                            <Grid item lg={6} md={12}>
                                <Typography variant="h1" fontSize={30} lineHeight="33px" fontWeight="500" color="#404349">
                                    {category}
                                </Typography>
                                <Typography fontSize={14} fontWeight="fontWeightLight" variant="label" color="#A3A3A3">
                                    {t('competency.totalCompetency')}: <span style={{ color: '#5DA196' }}> {filteredList.length}</span> {t('competency.competencies')}
                                </Typography>
                            </Grid>
                            <Grid item sm={6} xs={6} sx={{ display: "flex", "flex-flow": "row", "justify-content": "flex-end" }}>
                                <TextField
                                    id="input-with-icon-textfield"
                                    fullWidth
                                    placeholder={t('label.search')}
                                    size="small"
                                    sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" }, marginRight: "30px" }}
                                    className="searchTextField-h40"
                                    value={search}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search style={{ color: "#C4C4C4" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <MenuFilter statusOpen={statusOpen} openMenu={openMenu} notEvaluated={notEvaluated} evaluated={evaluated} EditEvaluated={EditNotEvaluated} />
                            </Grid>
                        </Grid>
                    </Grid>
                    {currentData !== undefined && currentData.length > 0 ?
                        <Box item sx={{ display: "flex", "flex-flow": "row wrap", margin: "-15px -15px" }} pt={3}>
                            {currentData.map((rs, order) => (
                                <Box item sx={styles.box} onClick={e => navigate(member !== undefined && member !== null ? `/kpi/competency/detail/${rs.serial}/${member}` : `/kpi/competency/detail/${rs.serial}`, { replace: false })}>
                                    <Box sx={styles.content}>
                                        <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                            <Box>
                                                <Typography fontSize={20} fontWeight="500" color="#404349"
                                                    sx={{
                                                        wordBreak: "break-word",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: "2",
                                                        WebkitBoxOrient: "vertical",
                                                    }}>
                                                    {formatData(rs.name, "-")}
                                                </Typography>
                                                <Typography fontSize={16} fontWeight="400" color="#404349">
                                                    {formatData(rs.code, "-")}
                                                </Typography>
                                            </Box>
                                            {rs?.is_evaluate === true ?
                                                <Box sx={{ width: "190px", minWidth: "190px" }}>
                                                    <Box sx={{ background: "rgba(93, 161, 150, 0.1)", "border-radius": "5px", padding: "8px 44px", textAlign: "center" }}>
                                                        <Typography fontSize={16} fontWeight="400" variant="label" color="primary" >
                                                            {t('competency.evaluated')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                : null}
                                        </Box>
                                        <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", }}>
                                            <Divider />
                                        </Box>
                                        {rs?.proficiency !== undefined && rs?.proficiency !== null && rs?.proficiency !== "" ?
                                            <Box sx={{ "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "center" }}>
                                                <Box sx={{ width: "33.33%" }}>
                                                    <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                        {t('competency.proficiency')}:
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "66.67%" }}>
                                                    <Typography fontSize={18} fontWeight="400" color="#404349">
                                                        {t('competency.level')} {formatData(rs?.proficiency?.level, "-")} - {formatData(rs?.proficiency?.description, "-")}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            : null
                                        }
                                        <Box sx={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                            <Box sx={{ width: "33.33%" }}>
                                                <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                    {t('competency.expectedRating')}:
                                                </Typography>
                                            </Box>
                                            {rs?.expected_rating?.value !== undefined && rs?.expected_rating?.value !== null && rs?.expected_rating?.value !== "" ?
                                                <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                    <StyledRating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={formatData(Number(rs?.expected_rating?.value).toFixed(1), 0)} max={1} />
                                                    <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                        {formatData(Number(formatData(rs?.expected_rating?.value, "0")).toFixed(1), "0")}
                                                    </Typography>
                                                    <Box sx={{ width: "100%", position: "relative" }}>
                                                        <div style={{ width: "max-content" }}>
                                                            <BootstrapTooltip
                                                                // PopperProps={{
                                                                //     disablePortal: true,
                                                                // }}
                                                                // style={{ width: "max-content" }}
                                                                // onClose={e => handleTooltipOpen(rs?.serial)}
                                                                // open={open === true && valueSerial === rs?.serial ? true : false}
                                                                placement="right"
                                                                arrow
                                                                // disableFocusListener
                                                                // disableHoverListener
                                                                // disableTouchListener
                                                                title={<span dangerouslySetInnerHTML={{ __html: formatData(rs?.expected_rating?.description, "-") }} />}
                                                            >
                                                                <TooltipIcon />
                                                            </BootstrapTooltip>
                                                            {/* <div className='tooltip' onClick={e => handleTooltipOpen(rs?.serial)} style={{ width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                        </div>
                                                    </Box>
                                                </Box>
                                                :
                                                <Box sx={{ width: "66.67%", display: "flex", 'align-items': "center", }}>
                                                    <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                        {formatData(rs?.expected_rating?.value, "-")}
                                                    </Typography>
                                                </Box>
                                            }
                                        </Box>
                                        <Box sx={{ "padding-top": "15px", "padding-bottom": "15px", display: "flex", "justify-content": "space-between", "align-items": "flex-start" }}>
                                            <Box sx={{ width: "33.33%" }}>
                                                <Typography fontSize={18} fontWeight="400" variant="label" color="#A3A3A3">
                                                    {t('competency.category')}:
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "66.67%" }} style={styles.boxTwoContent}>
                                                <Box>
                                                    <Typography fontSize={18} fontWeight="400" color="#404349">
                                                        {formatData(rs?.category, "-")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={styles.twoContent}>
                                                    <BootstrapTooltip title={`${t('competency.achievementActivity')}: ${formatData(rs?.achievement_count, "0")}`} placement="top">
                                                        <ListFile style={{ cursor: "pointer" }} />
                                                    </BootstrapTooltip>
                                                    <Typography pl={1} pr={2} fontSize={16} color="#A3A3A3" fontWeight="400" component="span">
                                                        {formatData(rs?.achievement_count, "0")}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        :
                        <Grid item sx={styles.emty} mt={3} >
                            <img src={emty} alt="emtyData"></img>
                            <Typography pt={1} fontSize={16} fontWeight="fontWeightLight" variant="label">{t('competency.empty')}</Typography>
                        </Grid>
                    }
                    <Grid container mt={1} spacing={2}>
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={10}>
                                    <Typography style={{ fontWeight: "300" }}>10</Typography>
                                </MenuItem>
                                <MenuItem value={20}>
                                    <Typography style={{ fontWeight: "300" }}>20</Typography>
                                </MenuItem>
                                <MenuItem value={30}>
                                    <Typography style={{ fontWeight: "300" }}>30</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>

                </Container>
            </Box>
        </>
    );
};
export default SeeAllCompetency;
